export const getFirstNonEmptyId = (ids = []) => {
  const id = (Array.isArray(ids) ? ids : []).find((item) => typeof item === 'string' && item.trim())
  return typeof id === 'string' ? id.trim() : ''
}

export const getEffectiveStudentIds = (ids = []) => {
  const seen = new Set()
  return (Array.isArray(ids) ? ids : []).reduce((result, id) => {
    const normalizedId = typeof id === 'string' ? id.trim() : ''
    if (normalizedId && !seen.has(normalizedId)) {
      seen.add(normalizedId)
      result.push(normalizedId)
    }
    return result
  }, [])
}

export const studentBelongsToParent = (student, parentUserId) => {
  if (!parentUserId) return true
  return (student?.studentInfo?.parents || []).some(
    ({ parentUserId: relatedParentId }) => relatedParentId === parentUserId
  )
}

export const parseDateInputAsUTC = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
    ? { year, month, day }
    : null
}

const getDaysInUTCMonth = (year, monthIndex) => new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate()

export const getSchoolYearStart = (now) => {
  const year = now.getUTCFullYear() - (now.getUTCMonth() < 7 ? 1 : 0)
  return new Date(Date.UTC(year, 7, 1, 0, 0, 0, 0))
}

export const subtractCalendarMonthsUTC = (now, months) => {
  const sourceYear = now.getUTCFullYear()
  const sourceMonth = now.getUTCMonth()
  const targetMonthIndex = sourceMonth - months
  const targetYear = sourceYear + Math.floor(targetMonthIndex / 12)
  const targetMonth = ((targetMonthIndex % 12) + 12) % 12
  const targetDay = Math.min(now.getUTCDate(), getDaysInUTCMonth(targetYear, targetMonth))
  return new Date(Date.UTC(targetYear, targetMonth, targetDay, 0, 0, 0, 0))
}

export const buildStatementPeriodParams = ({ period, now, fromDate, toDate }) => {
  switch (period) {
    case 'schoolYear':
      return {
        statementFrom: getSchoolYearStart(now).toISOString(),
        statementTo: now.toISOString()
      }
    case 'lastThreeMonths':
      return {
        statementFrom: subtractCalendarMonthsUTC(now, 3).toISOString(),
        statementTo: now.toISOString()
      }
    case 'outstanding':
      return { status: ['pendingPayment', 'unPaid'] }
    case 'custom': {
      const from = parseDateInputAsUTC(fromDate)
      const to = parseDateInputAsUTC(toDate)
      return {
        statementFrom: from ? new Date(Date.UTC(from.year, from.month - 1, from.day, 0, 0, 0, 0)).toISOString() : undefined,
        statementTo: to ? new Date(Date.UTC(to.year, to.month - 1, to.day, 23, 59, 59, 999)).toISOString() : undefined
      }
    }
    default:
      return {}
  }
}

export const getSchoolYearSubtitle = (now) => `Aug ${getSchoolYearStart(now).getUTCFullYear()} – present`
